var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-statements */
import loadScript from '../../utils/loadScript';
import logger from '../../config/app.logger';
import { getExtendedLogger } from '../Logger';
import { getBerryAuthToken, getBerryWidgetStyle } from './utils';
import { isAdminSite } from '../../utils';
import { BERRY_APP_WIDGET_URL, LOGGER_NAME, BERRY_EVENT_ORIGIN, BERRY_APP_EVENT_HANDLERS_TYPES, ADMIN_BOT_NAME, LEARNER_BOT_NAME, BERRY_ENABLED_TYPES, } from './constant';
var log = getExtendedLogger(LOGGER_NAME, logger);
var berryInitialised = null;
var handOffData = {};
export function loadBerry() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadScript({
                        url: BERRY_APP_WIDGET_URL,
                        defer: true,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function attachEventHandlers(eventHandlers) {
    var onBerryHandOff = eventHandlers.onBerryHandOff, onBerryHandShake = eventHandlers.onBerryHandShake;
    window.addEventListener('message', function (event) {
        // Check the origin of the message for security
        if (event.origin !== BERRY_EVENT_ORIGIN) {
            return;
        }
        var message = event.data;
        // Your code to handle the message goes here
        if (message.type === BERRY_APP_EVENT_HANDLERS_TYPES.BERRY_HANDOFF_EVENT) {
            onBerryHandOff === null || onBerryHandOff === void 0 ? void 0 : onBerryHandOff(event.data);
        }
        if (message.type === BERRY_APP_EVENT_HANDLERS_TYPES.BERRY_WIDGET_HANDSHAKE) {
            berryInitialised = true;
            onBerryHandShake === null || onBerryHandShake === void 0 ? void 0 : onBerryHandShake();
        }
    });
}
function prepareOptionsFromConfig(config) {
    var token = config.token, primaryColor = config.primaryColor, _a = config.isOpenByDefault, isOpenByDefault = _a === void 0 ? false : _a, customerId = config.customerId, berryBotUrlPath = config.berryBotUrlPath, toggleIconUrl = config.toggleIconUrl, customProps = config.customProps;
    var isAdmin = !!isAdminSite();
    var botUrlPath = berryBotUrlPath || (isAdmin ? ADMIN_BOT_NAME : LEARNER_BOT_NAME);
    var position = isAdmin
        ? { side: 'right', offsetX: 24, offsetY: 96 }
        : { side: 'right', offsetX: 24, offsetY: 24 };
    return {
        token: token,
        position: position,
        primaryColor: primaryColor,
        botUrlPath: botUrlPath,
        isOpenByDefault: isOpenByDefault,
        hideToggle: true,
        showClose: true,
        hideSendIcon: true,
        showResize: true,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
        toggleSize: 48,
        headerLeftAligned: true,
        hideChatHistory: false,
        customerId: customerId,
        customFont: 'Inter',
        tooltip: 'Chat with support',
        toggleIconUrl: toggleIconUrl,
        customProps: customProps,
    };
}
function loadBerryApp(config, eventHandlers) {
    if (eventHandlers === void 0) { eventHandlers = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var response, options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBerryAuthToken()];
                case 1:
                    response = _a.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.token)) {
                        berryInitialised = false;
                        log('Token not present, skipping loading phase. Berry will not be loaded due to token not present.');
                        return [2 /*return*/];
                    }
                    options = prepareOptionsFromConfig(__assign(__assign({}, config), { token: response === null || response === void 0 ? void 0 : response.token }));
                    return [4 /*yield*/, loadBerry()];
                case 2:
                    _a.sent();
                    if (!Berry) {
                        log('not loaded, skipping initialisation phase');
                        berryInitialised = false;
                        return [2 /*return*/];
                    }
                    log('initialising with options %o', options);
                    Berry === null || Berry === void 0 ? void 0 : Berry.init(options);
                    berryInitialised = true;
                    attachEventHandlers(eventHandlers);
                    return [2 /*return*/];
            }
        });
    });
}
var showBerry = function () {
    Berry === null || Berry === void 0 ? void 0 : Berry.show();
};
var hideBerry = function () {
    Berry === null || Berry === void 0 ? void 0 : Berry.hide();
};
var isBerryInitialized = function () { return berryInitialised; };
var toggleBerryIcon = function (_a) {
    var showIcon = _a.showIcon;
    Berry === null || Berry === void 0 ? void 0 : Berry.setToggleVisibility(showIcon);
};
var toggleBerrychat = function (_a) {
    var hideButton = _a.hideButton, _b = _a.hideChatbox, hideChatbox = _b === void 0 ? true : _b;
    try {
        toggleBerryIcon({ showIcon: !hideButton });
        hideChatbox ? hideBerry() : showBerry();
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
};
// This function is used in learner-header for updating the sendFeedbackFromBerry function
var updateSendFeedbackFromBerry = function (callback) {
    log('sendFeedbackFromBerry function updated with get support function.');
    if (isBerryInitialized() && callback) {
        Berry.sendFeedbackFromBerry = callback;
    }
};
var sendFeedbackFromBerry = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(Berry === null || Berry === void 0 ? void 0 : Berry.sendFeedbackFromBerry)) return [3 /*break*/, 2];
                return [4 /*yield*/, (Berry === null || Berry === void 0 ? void 0 : Berry.sendFeedbackFromBerry(data))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
            case 2:
                log('Could not call sendfeedback from getsupport as it was not updated using function updateSendFeedbackFromBerry');
                return [2 /*return*/];
        }
    });
}); };
var updateBerryHandoffData = function (data) {
    if (isBerryInitialized()) {
        handOffData = data;
    }
    else {
        // eslint-disable-next-line no-unused-vars
        handOffData = {};
    }
};
var getBerryHandoffData = function () { return handOffData || {}; };
var isBerryEnabled = function (enabledType) {
    return enabledType && Object.values(BERRY_ENABLED_TYPES).includes(enabledType);
};
var isBerryEnabledForAdmin = function (enabledType) {
    return BERRY_ENABLED_TYPES.ADMIN === enabledType || BERRY_ENABLED_TYPES.BOTH === enabledType;
};
var isBerryEnabledForLearner = function (enabledType) {
    return BERRY_ENABLED_TYPES.LEARNER === enabledType || BERRY_ENABLED_TYPES.BOTH === enabledType;
};
var updateProperties = function (customProperties) {
    if (isBerryInitialized()) {
        Berry === null || Berry === void 0 ? void 0 : Berry.update({ customProps: customProperties });
    }
};
export { loadBerryApp, showBerry, hideBerry, isBerryInitialized, toggleBerryIcon, toggleBerrychat, getBerryWidgetStyle, sendFeedbackFromBerry, updateSendFeedbackFromBerry, isBerryEnabled, isBerryEnabledForAdmin, isBerryEnabledForLearner, updateBerryHandoffData, getBerryHandoffData, updateProperties, };
//# sourceMappingURL=helpers.js.map